@for (definition of stepsDefinition; track definition.property) {
  <app-cts-gantry-functional-unit-step-tile
    [status]="functionalUnit[definition.property]"
    [isSuccessful]="definition.property === 'standBy'"
    [showStatusIcon]="definition.property === 'standBy'"
  >
  </app-cts-gantry-functional-unit-step-tile>
}
